import { z } from 'zod';

export const formSchema = z.object({
  invoiceNumber: z.string().optional(),
  companyIds: z.array(z.string()).optional(),
  productIds: z.array(z.string()).optional(),
  agDate: z
    .object({
      from: z.date().optional(),
      to: z.date().optional(),
    })
    .optional(),
});

export type FormSchema = z.infer<typeof formSchema>;